module.exports = __webpack_public_path__ + "static/media/mage_dashboard.0375e8a0.svg";